var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "activity" } }, [
    _c("div", { staticClass: "activity-holder" }, [
      _c("div", { staticClass: "header", class: { green: _vm.mobile } }, [
        _vm._v("Recent Activity\n      "),
        _vm.mobile
          ? _c(
              "div",
              { staticClass: "close" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", fab: "", small: "" },
                    on: {
                      click: function($event) {
                        _vm.routeRemoveQuery("activity")
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { medium: "" } }, [
                      _vm._v("mdi-close")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("vo-list", {
            staticClass: "list",
            attrs: {
              fill: "",
              lazy: "",
              itemComponent: "vo-activity-list",
              list: _vm.app.activity.list
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "v-btn",
            {
              staticClass: "button",
              attrs: { flat: "", block: "" },
              on: {
                click: function($event) {
                  _vm.routeRemoveQuery("activity")
                }
              }
            },
            [
              _c("v-icon", { staticClass: "icon", attrs: { large: "" } }, [
                _vm._v("mdi-chevron-up")
              ])
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee341882", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee341882","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity.vue
// module id = 440
// module chunks = 4